<script src="../../main.js"></script>
<template>

    <div style="display: grid;background-color:  #E0E0E0;">

        <div style="display: grid;width: 100%;">
            <!--                <el-image  slot="item-icon" :src="pmsSkuInfo.skuDefaultImgUrl" alt="">-->
            <img style="width: 100%;" :src="pmsSkuInfo.skuDefaultImgUrl"></img>
            <span style="font-size: 18px;font-weight: 600;letter-spacing:4px;margin: 20px;">品名：{{merchantAddress}}{{pmsSkuInfo.skuName}}</span>
        </div>
        <div style="display: grid;place-items: center;">

            <div class="frame">
                <div style="display: flex;place-items: center;width: 100%;">
                    <div style="display:flex;justify-content: space-around;width: 100%;">
                        <div style="display: grid;place-items: center;">
                            <div style="font-weight: 600;font-family: PingFangSC,KaiTi,serif;letter-spacing: 8px;color: rgba(0, 0, 0, 1);font-size: 21px;">
                                全程追溯
                            </div>
                            <div style="font-weight: 600;font-family: PingFangSC,KaiTi,serif;letter-spacing: 8px;color: rgba(0, 0, 0, 1);font-size: 21px;">
                                放心购买
                            </div>
                            <div style="font-size: 10px;letter-spacing: 1px;font-family: PingFangSC,KaiTi,serif;color:rgba(102, 102, 102, 1);letter-spacing: 2px;opacity: 1;">
                                追溯辨识码：{{traceabilityDetails.traceabilityIdentificationCode}}
                            </div>
                        </div>
                        <div style="display: flex;">
                            <div style="display: flex;justify-content: center;align-items: center;margin-bottom: 40px;">
                                <img style="width: 15px;height: 15px;border-radius: 50%;"
                                     src="../../assets/img/bc_prize_author.png">
                                <div style="letter-spacing: 1px;font-size: 12px;font-weight: 500;">溯源码</div>
                                <div class="triangle"></div>
                            </div>
                            <img class="imgTitle" slot="item-icon"
                                 :src="traceabilityDetails.dimensionalBarcode" alt="">
                        </div>

                    </div>

                </div>
            </div>

            <div class="frame">
                <div><img class="img" slot="item-icon"
                          src="../../assets/img/种植主题图标.svg" alt="">
                </div>
                <div style="display: grid;">
                    <div class="textTitle">种植主体</div>
                    <div class="text">农基编号：{{traceabilityDetails.merchantCode}}</div>
                    <div class="text">农基商名称：{{traceabilityDetails.merchantName}}</div>
                    <div class="text">农基区域：{{traceabilityDetails.merchantAddress}}</div>
                    <!--                <div class="text">所在位置：查看 ></div>-->
                </div>
            </div>

            <div class="frame">
                <div><img class="img" slot="item-icon"
                          src="../../assets/img/播种移栽图标.svg" alt="">
                </div>
                <div style="display: grid;">
                    <div class="textTitle">播种移栽</div>
                    <div class="text">种子名称：{{traceabilityDetails.seedName}}</div>
                    <div class="text">种植面积：{{traceabilityDetails.plantingArea}}</div>
                    <div class="text">种植时间：{{traceabilityDetails.plantingTime}}</div>
                    <div class="text">种植数量：{{traceabilityDetails.plantingQuantity}}</div>
                    <div class="text">种植方式：{{traceabilityDetails.plantingPatterns}}</div>
                </div>
            </div>

            <div class="frame">
                <div><img class="img" slot="item-icon"
                          src="../../assets/img/施肥管理图标.svg" alt="">
                </div>
                <div style="display: grid;">
                    <div class="textTitle">施肥管理</div>
                    <div class="text">施肥时间：{{traceabilityDetails.fertilizationTime}}</div>
                    <div class="text">肥料名称：{{traceabilityDetails.fertilizationName}}</div>
                    <div class="text">肥料类型：{{traceabilityDetails.fertilizerType}}</div>
                    <div class="text">每亩用量：{{traceabilityDetails.usagePerMu}}</div>
                    <div class="text">施肥方式：{{traceabilityDetails.fertilizationType}}</div>
                </div>
            </div>

            <div class="frame">
                <div><img class="img" slot="item-icon"
                          src="../../assets/img/病虫害防治图片.svg" alt="">
                </div>
                <div style="display: grid;">
                    <div class="textTitle">病虫害防治</div>
                    <div class="text">病害名称：{{traceabilityDetails.diseaseName}}</div>
                    <div class="text">药剂名称：{{traceabilityDetails.drugName}}</div>
                    <div class="text">防治时间：{{traceabilityDetails.administerTime}}</div>
                    <div class="text">防治类型：{{traceabilityDetails.administerType}}</div>
                    <div class="text">防治机构：{{traceabilityDetails.administerInstitution}}</div>
                </div>
            </div>

            <div class="frame">
                <div><img class="img" slot="item-icon"
                          src="../../assets/img/采收管理图标.svg" alt="">
                </div>
                <div style="display: grid;">
                    <div class="textTitle">采收管理</div>
                    <div class="text">采收负责人：{{traceabilityDetails.recoveryHeadName}}</div>
                    <div class="text">采收人数：{{traceabilityDetails.recoveryPeopleNumber}}</div>
                    <div class="text">采收类型：{{traceabilityDetails.recoveryType}}</div>
                    <div class="text">采收时间：{{traceabilityDetails.recoveryTime}}</div>
                    <div class="text">甜度范围：{{traceabilityDetails.sweetnessMin}} - {{traceabilityDetails.sweetnessMax}}
                    </div>
                </div>
            </div>

            <div class="frame">
                <div><img class="img" slot="item-icon"
                          src="../../assets/img/产出初级品图标.svg" alt="">
                </div>
                <div style="display: grid;">
                    <div class="textTitle">产出初级品</div>
                    <div class="text">产出物名称：{{traceabilityDetails.outPutName}}</div>
                    <div class="text">产出数量：{{traceabilityDetails.outPutNum}}</div>
                    <div class="text">产出单位：{{traceabilityDetails.outPutUnit}}</div>
                </div>
            </div>

            <div class="frame">
                <div><img class="img" slot="item-icon"
                          src="../../assets/img/产品加工图标.svg" alt="">
                </div>
                <div style="display: grid;">
                    <div class="textTitle">产品加工</div>
                    <div class="text">加工企业：{{traceabilityDetails.processingEnterprises}}</div>
                    <div class="text">加工方式：{{traceabilityDetails.processingType}}</div>
                    <div class="text">生产许可证号：{{traceabilityDetails.productionLicenseNumber}}</div>
                    <div class="text">执行标准：{{traceabilityDetails.executiveStandards}}</div>
                    <div class="text">包装方式：{{traceabilityDetails.packagingType}}</div>
                </div>
            </div>

            <div class="frame">
                <div><img class="img" slot="item-icon"
                          src="../../assets/img/质量管理检验.svg" alt="">
                </div>
                <div style="display: grid;">
                    <div class="textTitle">质量检验</div>
                    <div class="text">质检机构：{{traceabilityDetails.qualityInspectionInstitution}}</div>
                    <div class="text">质检机构地址：{{traceabilityDetails.qualityInspectionInstitutionAddress}}</div>
                    <div class="text">质检方式：{{traceabilityDetails.qualityInspectionType}}</div>
                    <div class="text">质检类项：{{traceabilityDetails.qualityInspectionItems}}</div>
                    <div class="text">质检时间：{{traceabilityDetails.qualityInspectionTime}}</div>
                    <div class="text">
                        质检报告：共{{traceabilityDetails.qualityInspectionReport!=null?traceabilityDetails.qualityInspectionReport.length:0}}份
                        <a @click="openViewer(traceabilityDetails.qualityInspectionReport)"
                           style="color: rgba(47, 178, 136, 1);">查看></a></div>
                </div>
            </div>

            <div class="frame">
                <div><img class="img" slot="item-icon"
                          src="../../assets/img/地理标志图标.svg" alt="">
                </div>
                <div style="display: grid;">
                    <div class="textTitle">地理标志产品</div>
                    <div class="text">发证机关：{{traceabilityDetails.licenceIssuingAuthority}}</div>
                    <div class="text">登记证书编号：{{traceabilityDetails.geographyCertificateNo}}</div>
                    <div class="text">核准登记产品全称：{{traceabilityDetails.geographyProductName}}</div>
                    <div class="text">登记申请人全称：{{traceabilityDetails.geographyApplyName}}</div>
                    <div class="text">产品生产总规模：{{traceabilityDetails.productTotalProductionScale}}</div>
                    <div class="text">质量控制规范编号：{{traceabilityDetails.qualityControlNumber}}</div>
                    <div class="text">登记时间：{{traceabilityDetails.registrationTime}}</div>
                    <div class="text">
                        登记证书：共{{traceabilityDetails.registrationCertificate!=null?traceabilityDetails.registrationCertificate.length:0}}份
                        <a @click="openViewer(traceabilityDetails.registrationCertificate)"
                           style="color: rgba(47, 178, 136, 1);">查看></a></div>

                </div>
            </div>

            <div class="frame">
                <div><img class="img" slot="item-icon"
                          src="../../assets/img/特色文化名片图标.svg" alt="">
                </div>
                <div style="display: grid;">
                    <div class="textTitle">特色文化名片</div>
                    <div class="text">地域位置：{{traceabilityDetails.geographicalLocation}}</div>
                    <div class="text">人文景观：{{traceabilityDetails.placeCulturalInterest}}</div>
                    <div class="text">美食特产：{{traceabilityDetails.foodSpecialties}}</div>
                    <div class="text">非遗文化：{{traceabilityDetails.intangibleCulturalHeritage}}</div>
                    <div class="text">
                        数字名片：共{{traceabilityDetails.digitalBusinessCard!=null?traceabilityDetails.digitalBusinessCard.length:0}}份
                        <a @click="openViewer(traceabilityDetails.digitalBusinessCard)"
                           style="color: rgba(47, 178, 136, 1);">查看></a></div>

                </div>
            </div>

            <div class="frame">
                <div><img class="img" slot="item-icon"
                          src="../../assets/img/生产者感言图标.svg" alt="">
                </div>
                <div style="display: grid;">
                    <div class="textTitle">生产者感言</div>
                    <div class="text">生产者名称：{{traceabilityDetails.producerName}}</div>
                    <div class="text">发表感言：{{traceabilityDetails.giveSpeech}}</div>
                    <div class="text">
                        现场实拍：共{{traceabilityDetails.liveFilming!=null?traceabilityDetails.liveFilming.length:0}}份 <a
                            @click="openViewer(traceabilityDetails.liveFilming)"
                            style="color: rgba(47, 178, 136, 1);">查看></a></div>
                </div>
            </div>

            <viewer :images="showUrlList" ref="viewer" :key="viewerKey">
                <img v-for="(item, index) in showUrlList" :key="index"/>
            </viewer>
        </div>
    </div>


</template>

<script>
    import {
        newVue, queryTraceability
    } from "../../network/skuInfo";

    export default {
        name: "traceabilityDetails",
        components: {},
        data() {
            return {
                traceabilityDetails: {},
                pmsSkuInfo: {},
                showUrlList: [],
                showUrl: "",
                showBigImg: false,
                viewerKey: "",
                merchantAddress:""
            }
        },
        computed: {},
        created() {
            if (this.$route.params.id != null) {
                queryTraceability(this.$route.params.id, "Y").then(res => {
                    console.log(res.data);
                    if (res.data.pmsSkuInfo) {
                        this.pmsSkuInfo = res.data.pmsSkuInfo;
                    }
                    this.traceabilityDetails = res.data;
                    this.traceabilityDetails.fertilizerType = this.getStatusTest(this.traceabilityDetails.fertilizerType);
                    this.traceabilityDetails.fertilizationType = this.getStatusTest(this.traceabilityDetails.fertilizationType);
                    this.traceabilityDetails.administerType = this.getStatusTest(this.traceabilityDetails.administerType);
                    this.traceabilityDetails.recoveryType = this.getStatusTest(this.traceabilityDetails.recoveryType);
                    this.traceabilityDetails.processingType = this.getStatusTest(this.traceabilityDetails.processingType);
                    if (res.data.merchantAddress){
                        this.merchantAddress = res.data.merchantAddress.replace(' / ','');
                    }
                })
            }
        },
        methods: {
            openViewer(list) {
                if (list.length > 0) {
                    this.showUrlList = [];
                    for (let i = 0; i < list.length; i++) {
                        this.showUrlList.push(list[i].url);
                    }
                    this.showUrl = list[0].url;
                    this.showBigImg = true;
                    this.$viewerApi({
                        images: this.showUrlList
                    })
                }
            },
            getStatusTest(val) {
                var name = "";
                switch (val) {
                    case "OrganicFertilizers":
                        name = "有机化肥";
                        break;
                    case "EnzymeComposting":
                        name = "酵素堆肥";
                        break;
                    case "HumicAcidFertilizer":
                        name = "腐植酸肥料";
                        break;
                    case "SeaweedFertilizer":
                        name = "海藻肥料";
                        break;
                    case "MulticomponentFertilizer":
                        name = "多种混合肥料";
                        break;
                    case "ArtificialFertilization":
                        name = "人工施肥";
                        break;
                    case "MechanicalFertilization":
                        name = "机械施肥";
                        break;
                    case "SemiManualFertilization":
                        name = "半人工施肥";
                        break;
                    case "Physics":
                        name = "物理防治干预";
                        break;
                    case "Biopharmaceuticals":
                        name = "喷洒生物药剂";
                        break;
                    case "ChemicalAgents":
                        name = "喷洒化学药剂";
                        break;
                    case "ManualHarvesting":
                        name = "人工采收";
                        break;
                    case "MechanicalHarvesting":
                        name = "机械采收";
                        break;
                    case "SemiManualHarvesting":
                        name = "半人工采收";
                        break;
                    case "Artificial":
                        name = "人工";
                        break;
                    case "Machinery":
                        name = "机械";
                        break;
                    case "SemiManual":
                        name = "半人工";
                        break;
                }
                return name;
            }
        },


    }
</script>

<style scoped>
    .frame {
        display: flex;
        /*border-radius: 5%;*/
        /*border: 1px solid #999999;*/
        width: 80%;
        margin-top: 10px;
        margin-bottom: 10px;
        background-color: #ffffff;
    }

    .img {
        width: 45px;
        height: 45px;
        margin: 5px 10px 15px 15px;
    }

    .imgTitle {
        width: 90px;
        height: 90px;
        /*margin-left: 15px;*/
    }

    .textTitle {
        margin: 10px 5px 5px 5px;
        font-weight: 600;
        font-family: PingFangSC, KaiTi, serif;
        color: rgba(0, 0, 0, 1);
    }

    .text {
        margin: 5px 0px 5px 5px;
        font-weight: 400;
        font-family: PingFangSC, KaiTi, serif;
        color: rgba(0, 0, 0, 1);
    }

    .triangle {
        width: 0px;
        height: 0px;
        border-left: 6px solid #2a2c36;
        border-top: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 6px solid transparent;
    }


</style>
